'use client'

import Box from '@mui/material/Box'

import AnimatatedTransactions from '@/components/AnimatedTransactions/AnimatatedTransactions'
import BusinessSpendForm from '@/components/BusinessSpendForm'
import GenericHero from '@/components/Hero/GenericHero'
import LearnMoreTiles from '@/components/LearnMoreTiles'
import PlugInAndGo from '@/components/PlugInAndGo'
import RequestDemo, { Sector } from '@/components/RequestDemo'
import AnalyticsFintech from '@/sections/AnalyticsFintech'
import AuditReadyFintech from '@/sections/AuditReadyFintech'
import EmissionCalculationsFintech from '@/sections/EmissionCalculationsFintech'
import EnableYourUsersFintech from '@/sections/EnableYourUsersFintech'
import FintechAndBankingLogos from '@/sections/FintechAndBankingLogos'
import IsoCertifiedFintech from '@/sections/IsoCertifiedFintech'
import Over50kCompaniesFintech from '@/sections/Over50kCompaniesFintech'
import PayhawkCaseStudyBox from '@/sections/PayhawkCaseStudyBox'
import { HUBSPOT_FORM_IDS } from '@/utills/constants'

export default function Page() {
    return (
        <>
            <Box>
                <GenericHero
                    chips={{
                        items: [
                            {
                                src: '/images/heros/chip-fintech-1.png',
                                width: 480,
                                height: 96,
                            },
                            {
                                src: '/images/heros/chip-fintech-2.png',
                                width: 480,
                                height: 96,
                            },
                            {
                                src: '/images/heros/chip-fintech-3.png',
                                width: 480,
                                height: 96,
                            },
                            {
                                src: '/images/heros/chip-fintech-4.png',
                                width: 480,
                                height: 96,
                            },
                        ],
                        gap: 6,
                    }}
                    backgroundImageMobile={'/images/heros/fintech-mobile.png'}
                    title={'Embed emission reporting into your platform. Fast.'}
                    description={
                        <>
                            Banks and fintechs grow monthly active users while accelerating net zero
                            by embedding emission calculations and high quality carbon removal into
                            their platform.
                        </>
                    }
                />
                <FintechAndBankingLogos />
            </Box>
            <LearnMoreTiles
                tiles={[
                    {
                        title: 'Win new customers',
                        description: 'Capture growing demand for scope 3 emission reporting.',
                        icon: '/icons/icon-win-customers.png',
                        scrollToSection: 'iso-certified',
                    },
                    {
                        title: 'Grow monthly active users',
                        description:
                            'Accelerate customer engagement with decision-useful emission analytics.',
                        icon: '/icons/icon-grow-users.png',
                        scrollToSection: 'analytics',
                    },
                    {
                        title: 'Build a climate positive legacy',
                        description:
                            'Enable your customers to contribute to impactful climate projects.',
                        icon: '/icons/icon-climate-projects.png',
                        scrollToSection: 'vetted-climate-projects',
                    },
                    {
                        title: 'Go live, fast',
                        description:
                            'Plug and play via a simple API integration and go live within weeks.',
                        icon: '/icons/icon-plug-in.png',
                        scrollToSection: 'plug-in-and-go',
                    },
                ]}
            />
            <Over50kCompaniesFintech />
            <Box id={'iso-certified'}>
                <IsoCertifiedFintech />
            </Box>
            <Box id={'calculator'}>
                <EmissionCalculationsFintech />
            </Box>
            <Box>
                <AnimatatedTransactions />
            </Box>
            <Box id={'audit-ready'}>
                <AuditReadyFintech />
            </Box>
            <Box id={'analytics'}>
                <AnalyticsFintech />
            </Box>
            <BusinessSpendForm hubspotFormId={HUBSPOT_FORM_IDS.businessSpend} />
            <Box id={'vetted-climate-projects'}>
                <EnableYourUsersFintech />
            </Box>
            <PayhawkCaseStudyBox />
            <Box id={'plug-in-and-go'}>
                <PlugInAndGo
                    items={[
                        {
                            backgroundImageUrl: '/illustrations/plug-in-and-go/api-green.png',
                            title: 'White label API integration',
                            description:
                                'Lune customers integrate our API within hours with support from our engineers.',
                        },
                        {
                            backgroundImageUrl:
                                '/illustrations/plug-in-and-go/spreadsheet-green.png',
                            title: 'Simple spreadsheet upload',
                            description:
                                'Get started immediately and upload your spend data via spreadsheet.',
                        },
                        {
                            backgroundImageUrl: '/illustrations/plug-in-and-go/offsetting.png',
                            title: 'Lune-hosted carbon offsetting page',
                            description:
                                'Enable your customers to contribute to vetted climate projects via Lune Pay. No code required.',
                        },
                    ]}
                />
            </Box>
            <RequestDemo sector={Sector.PAYMENTS} />
        </>
    )
}
